import { Row, Col } from 'reactstrap';
import { Filter } from 'common/Filter';
import { Search } from 'common/Search';
import ExportExcel from 'components/ExportExcel/ExportExcel';
import { partnerExcelConfig } from 'utils/excel/partnerExcelConfig';
import { formatPartnerData } from 'utils/excelFormat/formatPartnerData';
import { DatePicker } from 'common/DatePicker';
import { DATES } from 'common/DatePicker/dateConstant';

type GridFilterBarProps = {
  searchKeyword: string;
  filterCriteria: any;
  totalCount: number;
  onSearch: (searchTerm: string) => void;
  onClearSearch: () => void;
  allData?: any[];
};

export const GridFilterBar = ({
  searchKeyword = '',
  filterCriteria,
  totalCount,
  onSearch,
  onClearSearch,
  allData,
}: GridFilterBarProps) => {
  const formattedData = formatPartnerData(allData);

  return (
    <>
      {/* <Row className="mb-2">
        <Col sm={2} md={3} className="d-flex align-items-center mb-3 mb-md-0">
          <Search
            searchKeyword={searchKeyword}
            onSearch={onSearch}
            onClearSearch={onClearSearch}
          />
        </Col>

        <Col sm={6} md={5} className="d-flex align-items-center mb-3 mb-md-0">
          <Filter filterCriteria={filterCriteria} />
          <span className="mx-2 record-count-results">
            {totalCount} results
          </span>

          {allData && allData.length > 0 && (
            <ExportExcel allData={formattedData} config={partnerExcelConfig} />
          )}
        </Col>

        <Col className="" sm={4} md={4}>
          <DatePicker filterCriteria={DATES} />
          {allData && allData.length > 0 && (
            <ExportExcel allData={formattedData} config={partnerExcelConfig} />
          )}
        </Col>
      </Row> */}
      <Row>
        <Col className="col-3">
          <Search
            searchKeyword={searchKeyword}
            onSearch={onSearch}
            onClearSearch={onClearSearch}
          />
        </Col>
        <Col className='d-flex col-6 '>
          <Filter filterCriteria={filterCriteria} />
          <span className="mx-2 record-count-results">
            {totalCount} results
          </span>
        </Col>
        <Col className='d-flex justify-content-around' >
          <DatePicker filterCriteria={DATES} />
          {allData && allData.length > 0 && (
            <ExportExcel allData={formattedData} config={partnerExcelConfig} />
          )}
        </Col>
      </Row>
    </>
  );
};
